import * as amplitude from '@amplitude/analytics-browser';
import VueDatePicker from '@vuepic/vue-datepicker';
import vClickOutside from 'v-click-outside';
import { createApp } from 'vue';

import '@mdi/font/css/materialdesignicons.css';
import '@fontsource/roboto/100.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/900.css';
import '@fontsource/material-icons';
import './main.less';

// Initialize Amplitude BEFORE importing components
// (components import analytics service which checks for window.amplitude)
if (process.env.VUE_APP_AMPLITUDE_API_KEY) {
  amplitude.init(process.env.VUE_APP_AMPLITUDE_API_KEY);
  (window as any).amplitude = amplitude;
} else {
  console.warn('[Amplitude] API key not found in environment variables. Analytics tracking disabled.');
}

// Now import components (after Amplitude is initialized)
import App from './App.vue';
import CxMeasuredPointFilters from './app/filterPanel/asbuilts/CxMeasuredPointFilters.vue';
import CxSurfaceFilters from './app/filterPanel/asbuilts/CxSurfaceFilters.vue';
import { gettext } from './translations/gettext.setup';
import { CxTooltipDirective } from '@/components/tooltip/CxTooltipDirective';
import { storeFactory } from '@/root';

const app = createApp(App);
app.use(storeFactory());
app.use(gettext);

const { bind, unbind } = vClickOutside.directive;
app.directive('click-outside', {
  mounted(el, binding) {
    bind(el, { value: binding.value });
  },
  beforeUnmount(el) {
    unbind(el);
  },
});

app.directive('cx-tooltip', CxTooltipDirective);

app.component('CxMeasuredPointFilters', CxMeasuredPointFilters);
app.component('CxSurfaceFilters', CxSurfaceFilters);
app.component('VueDatePicker', VueDatePicker);

app.mount('#app');
